<template>
  <tbody :class="[showDetail ? 'isActive' : '', 'tbody']" v-if="trip">
    <tr>
      <td @click="showDetail = !showDetail">{{trip.corporateName}}</td>
      <td @click="showDetail = !showDetail">{{ trip.userInfo ? trip.userInfo.name : "" }}</td>
      <td
        @click="showDetail = !showDetail"
      >{{ trip.impersonatorInfo ? trip.impersonatorInfo.name : "" }}</td>
      <td @click="showDetail = !showDetail">{{ trip.time | moment("HH:mm DD MMM") }}</td>
      <td @click="showDetail = !showDetail">{{trip.statusMessage}}</td>
      <td @click="showDetail = !showDetail">{{trip.sourceMessage}}</td>
      <td @click="showDetail = !showDetail">{{trip.userTypeMessage}}</td>
    </tr>
    <tr v-if="showDetail" style="background-color:#E0F2F1">
      <td colspan="12">
        <table style="width:100%">
          <tr>
            <td colspan="3" style="width:25%">{{ trip.queryParams }}</td>
            <td colspan="3" style="width:25%">
              <small class="text-body-2" v-if="trip.userInfo ">
                {{ trip.userInfo.name}}
                <br />
                {{trip.userInfo.phone}}
                <br />
                {{trip.userInfo.email}}
              </small>
            </td>
            <td colspan="3" style="width:25%">
              <small class="text-body-2" v-if="trip.userInfo ">
                {{ trip.impersonatorInfo.name}}
                <br />
                {{trip.impersonatorInfo.phone}}
                <br />
                {{trip.impersonatorInfo.email}}
              </small>
            </td>
            <td colspan="3" style="width:25%"></td>
          </tr>
        </table>
      </td>
    </tr>
  </tbody>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
import common from "@/store/common/module/common";
import { doGet, doPost } from "@/store/common/module/apis";

@Component({
  name: "AccessRow",
  props: {
    value: {
      default: null,
    },
  },
})
export default class AccessRow extends Vue {
  trip = null;
  showDetail = false;

  mounted() {
    if (this.value) this.trip = this.value;
  }

  @Watch("value")
  onValueChange(val) {
    this.trip = val;
  }
}
</script>


<style scoped>
.tbody {
  height: 30px;
}
.tbody tr td {
  padding: 0 2px !important;
  cursor: pointer;
}

.tbody tr td .v-input--checkbox {
  padding: 0;
  height: 30px;
  margin-top: 8px;
}

.isActive,
.isActive:hover {
  background-color: #b2dfdb !important;
}
</style>